import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';

import store from '@/store';
import { ErrorAlertModule } from '@/store/modules/errors';
import { getStatementById } from '@/api/services';
import { updateDistrict } from '@/api/altDistrict';
import { IRequestParamDistrict } from '@/types/alternativeServices';
import { errorHandler } from '@/utils/common';
import { IStatement } from '@/types/services';

export interface IAltDistrictState {
  dataStatement: IStatement | null;
  loading: boolean;
  loaded: boolean;
}

@Module({ dynamic: true, store, name: 'AltDistrictModule', namespaced: true })
class AltDistrict extends VuexModule implements IAltDistrictState {
  public dataStatement: IAltDistrictState['dataStatement'] = null;
  public loaded = false;
  public loading = false;

  @Mutation
  private GET_PENDING() {
    ErrorAlertModule.setErrorAlert('');
    this.loaded = false;
    this.loading = true;
    this.dataStatement = null;
  }

  @Mutation
  private GET_FULFILLED(data: any) {
    this.dataStatement = { ...data };
    this.loading = false;
    this.loaded = true;
  }

  @Mutation
  private GET_REJECTED(error: unknown) {
    errorHandler(error);
    this.loading = false;
  }

  @Mutation
  private GET_PENDING_SEND() {
    ErrorAlertModule.setErrorAlert('');
    this.loading = true;
    this.loaded = false;
  }

  @Mutation
  private GET_FULFILLED_SEND() {
    this.loading = false;
    this.loaded = true;
  }

  @Action
  async getStatementById(id: string) {
    this.GET_PENDING();
    try {
      const data = await getStatementById(id);
      this.GET_FULFILLED(data);
    } catch (error) {
      this.GET_REJECTED(error);
    }
  }

  @Action
  async updateDistrict(requestParam: IRequestParamDistrict) {
    this.GET_PENDING_SEND();
    try {
      await updateDistrict(requestParam);
      this.GET_FULFILLED_SEND();
      return true;
    } catch (error) {
      this.GET_REJECTED(error);
      return false;
    }
  }
}

export const AltDistrictModule = getModule(AltDistrict);
